import types from './types'

const { CLEAR_EC_QUERY_PLATE } = types

function clearECQueryPlate() {
  return dispatch =>
    dispatch({
      type: CLEAR_EC_QUERY_PLATE,
      state: null
    })
}

export default clearECQueryPlate



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/clearECQueryPlate.js